import { StateHandler } from "../../../../core/utils/StateHandler";
import { Presentation } from '../../../../core/gameflow/controller/Presentation';
import { GameData } from '../../../server/data/GameData';
import { SanJumpData } from '../../../server/base/IData';
import { SanEngineManager } from "../../../engine/SanEngineManager";
import { SanQuentin2 } from "../../../SanQuentin2";
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { GameSetting } from "../../../../core/setting/GameSetting";
import { SoundManager } from "../../../config/sound/SoundManager";
import { SoundConfig } from "../../../config/sound/SoundConfig";
import { ScatterRevealPresentation } from "../../features/scatter/ScatterRevealPresentation";
import { ReavealerState } from '../../../modules/revealer/Revealer';
import { RevealerManager } from '../../../modules/revealer/RevealerManager';
import { ArrayHelper } from "../../../../core/utils/ArrayHelper";

class StopFlowState extends StateHandler {

    public static readonly NORMAL: string = "normal";
    public static readonly BONUS_START: string = "bonus_start";
    public static readonly BONUS_JUMP: string = "bonus_jump";
    public static readonly BONUS_BARS: string = "bonus_bars";
    public static readonly BONUS_STOP: string = "bonus_stop";
}

export class FSBarJWStopPresentation extends Presentation {

    // private nearWinLength: number = 0;
    // private nearWinPos: number[][] = [];
    // private possibleWinSymbols: string[][] = [];

    private stopFlow: StopFlowState = new StopFlowState(StopFlowState.NORMAL);
    private jumpData: SanJumpData[];
    private openedBar: boolean[];
    
    public setGameData(data: GameData): void {
        super.setGameData(data);
        this.jumpData = data.Reel.jumpData;

        this.openedBar = ArrayHelper.initArrayWithValues(data.raw.topBottomReelOpened.length, (i) =>{
            return RevealerManager.getBotBar(i).isActive && data.raw.topBottomReelOpened[i];
        })
    }

    public preStart(): void {
        this.stopFlow.set(StopFlowState.BONUS_START);
    }

    public createPresentation(skip:Function): void {

        switch (this.stopFlow.value) {
            case StopFlowState.BONUS_START:
                skip(false);
                this.BonusStart();
                break;
            case StopFlowState.BONUS_JUMP:
                this.BonusJump();
                break;
            case StopFlowState.BONUS_BARS:
                skip(!SanEngineManager.isQuickStop);
                this.timeline.timeScale(SanEngineManager.isQuickStop ? 4 : 1);
                this.BonusBars();
                break;
            case StopFlowState.BONUS_STOP:
                this.BonusStop();
                break;
            default:
                this.setPlayable(false);
        }
    }

    protected BonusStart(): void {

        const postDurr: number = this.timeline.add(SanQuentin2.postCounter.play()).duration();
        let spinLeft = SanQuentin2.postCounter.getAmount ? SanQuentin2.postCounter.getAmount : 0;
        this.timeline.add(() => SlotGame.keypadPlugin.setZeroBetSpinCounter(spinLeft), 0.3);

        if(!SanQuentin2.jumpingWildController._firstTimeApply){
            SanQuentin2.jumpingWildController.activeJW.forEach(jw =>{
                this.timeline.fromTo(jw, 0.2, { alpha: 1 }, { alpha: 0.55 }, 0);
                this.timeline.to(jw, 0.3, { alpha: 1 }, postDurr - 0.3);
            })
        }

        this.stopFlow.set(StopFlowState.BONUS_JUMP);
    }

    protected BonusJump(): void {

        let playSound: boolean = false;
        const jumpDurr: number = 0.5;

        if(SanQuentin2.xWaysCounter.isHiding){
            this.timeline.add(() => {
                SanQuentin2.xWaysCounter.counterActive(true,true)
            },jumpDurr*0.8)
        }
        SanQuentin2.jumpingWildController.activeJW.forEach((jw,indx) => {
            const jumpData = this.jumpData[indx];
            if(SanQuentin2.jumpingWildController._firstTimeApply)
                jw.alpha = 1;

            this.timeline.add(jw.JumpTo({
                reel: jumpData.to.reel,row:jumpData.to.row,duration:jumpDurr
            }),0)
            
            if (jw.multValue > 1) playSound = true;
        });
        if(SanQuentin2.jumpingWildController._firstTimeApply){
            SanQuentin2.jumpingWildController._firstTimeApply = false;
            SanQuentin2.setupPhase.setupJWSyms.forEach(jw =>{ jw.alpha = 0});
        }
        if (playSound)
            this.timeline.add(() => {SoundManager.playSoundEffect(SoundConfig.FS_MULT_TURN)}, 0.7);

        this.timeline.to(this, {duration:GameSetting.isFastSpin ? 0.1 : 0.2});
        this.stopFlow.set(StopFlowState.BONUS_BARS);

       
    }

    protected BonusBars(): void {

        let delay: number = 0;
        let expandDurr: number = 0;
        let multUpgrade: number = 0;

        let animDurr: number = 0.5;
        let glowDelay: number = 0.1 / (GameSetting.isFastSpin || SanEngineManager.isQuickStop ? 1.5 : 1);

        for (let tb: number = 0; tb < 2; tb++) {
            const isTopBar: boolean = tb == 0;
            this.timeline.add(() => {SoundManager.playSoundEffect(SoundConfig.FS_LINE_FIRE)}, delay);
            
            for (let r: number = 0; r < SanEngineManager.AllReels.length; r++) {
                if (this.openedBar[r]) {
                    this.timeline.add(() => { ScatterRevealPresentation.flashBarOnce(r, isTopBar)}, delay);
                    delay += glowDelay;
                }
            }

            delay += 0.4;

            for (let r: number = 0; r < SanEngineManager.AllReels.length; r++) {
                if (!this.openedBar[r]) continue;

                if (!SanEngineManager.isQuickStop) this.timeline.add(() => { ScatterRevealPresentation.flashBarFS(r, isTopBar)}, delay);
                this.timeline.add(() => { ScatterRevealPresentation.revealBarFS(r, isTopBar) }, delay);

                const animDD: number = (delay + animDurr);

                if (!isTopBar && RevealerManager.getBotBar(r).state.equal(ReavealerState.EXPANDING)) {
                    this.timeline.add(() => {RevealerManager.getBotBar(r).specialBarLand(1)}, animDD - 0.1);
                }
                else if (isTopBar && RevealerManager.getTopBar(r).state.equal(ReavealerState.EXPANDING)) {
                    this.timeline.add(() => {RevealerManager.getTopBar(r).specialBarLand(1)}, animDD - 0.1);
                }

                let playWildUpgradeSound: boolean = false;

                if (isTopBar && RevealerManager.getTopBar(r).state.equal(ReavealerState.SPLITTER)) {
                    RevealerManager.getBotBar(r).state.equal(ReavealerState.SPLITTER)
                    this.jumpData.forEach((jData,Indx) => {
                        if (jData.to.reel == r) {
                            playWildUpgradeSound = true;
                            const val: number = RevealerManager.getBotBar(r).state.equal(ReavealerState.SPLITTER) ? jData.to.multiplier! / 2 : jData.to.multiplier!;
                            this.timeline.add(() => SanQuentin2.jumpingWildController.getExistingItem(Indx).barJWUpgrade(), animDD);
                            multUpgrade = RevealerManager.getBotBar(r).state.equal(ReavealerState.SPLITTER) ? 2 : 1;
                        }
                    })
                }

                if (!isTopBar && RevealerManager.getBotBar(r).state.equal(ReavealerState.SPLITTER)) {
                    this.jumpData.forEach((jData,Indx) => {
                        if (jData.to.reel == r) {
                            playWildUpgradeSound = true;
                            this.timeline.add(() => SanQuentin2.jumpingWildController.getExistingItem(Indx).barJWUpgrade(), animDD);
                            multUpgrade = !multUpgrade ? 1 : multUpgrade;
                        }
                    })
                }

                if (playWildUpgradeSound) {
                    this.timeline.add(() => {SoundManager.playSoundEffect(SoundConfig.BONUS_WILD_FIRE)}, delay);
                }
                delay += animDurr / (GameSetting.isFastSpin ? 4 : 2);

            }
            delay += GameSetting.isFastSpin || SanEngineManager.isQuickStop ? 0 : 0.1;
        }
        
        this.timeline.to(this, {duration:0.2 + Math.max(multUpgrade, expandDurr)});
        this.setPlayable(false);
        // this.stopFlow.set(StopFlowState.BONUS_STOP);
    }

    protected BonusStop(): void {
        SanEngineManager.AllReels.forEach((r) => {
            // r.isActive && r.changeAlpha(0.35, 0.25);
        });
        this.setPlayable(false);
    }

    skip():void{
        SanEngineManager.isQuickStop = true;
        this.timeline.timeScale(4);
    }
    
    public done(): void {
    }
}